/** Revalidate any cached allpanel downline list for this parent (any page, tab, or search). */
export const swrKeyMatchesAllpanelDownlineList =
  (parentUserId: string) =>
  (key: unknown): boolean =>
    typeof key === "string" && key.startsWith(`member/allpanelDownlineList/${parentUserId}`);

export const swrKeyMatchesAllpanelStatistics =
  (adminId: string) =>
  (key: unknown): boolean =>
    typeof key === "string" && key.startsWith(`member/allpanelStatistics/${adminId}`);
